import { ReactNode } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import RefreshIcon from "@mui/icons-material/Refresh";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export const ERROR_STATE_TITLE = "A lista não carregou";

export type ErrorStateProps = { title?: string; description?: ReactNode; onRetry?: () => void; retryLabel?: string };

export default function ErrorState({ title = ERROR_STATE_TITLE, description, onRetry, retryLabel = "Tentar de novo" }: ErrorStateProps) {
  return (
    <Box role="alert" sx={{ py: 6, px: 2, textAlign: "center", maxWidth: 480, mx: "auto" }}>
      <Box sx={{ width: 56, height: 56, borderRadius: "50%", bgcolor: "#fdecec", display: "grid", placeItems: "center", mx: "auto", mb: 1.5 }}>
        <WarningAmberIcon sx={{ fontSize: 28, color: "#c62828" }} aria-hidden />
      </Box>
      <Typography sx={{ fontWeight: 600, fontSize: 15 }}>{title}</Typography>
      {description && <Typography sx={{ color: "text.secondary", fontSize: 13, mt: 0.5 }}>{description}</Typography>}
      <Typography sx={{ color: "text.secondary", fontSize: 13 }}>Os filtros continuam aplicados.</Typography>
      {onRetry && (
        <Button variant="contained" startIcon={<RefreshIcon />} onClick={onRetry} sx={{ mt: 2 }}>
          {retryLabel}
        </Button>
      )}
    </Box>
  );
}
